import type { MooAction } from "../../types/moo";

/** Keep a transaction editor attached to its entry across revisions and removals. */
export function mooEntryKey(messageId: string, action: MooAction, index: number) {
  return `${messageId}:${action.kind}:${action.expense?.requestId || action.id || index}`;
}
